import React, { useMemo, useState } from 'react';
import { Select, Spin } from 'antd';
import { useSelectableApplicationsQuery } from './useSelectableApplicationsQuery';
import { buildSelectableApplicationSelectOptions } from './selectableApplicationOptions';

export type AvailableApplicationPickerProps = {
  value?: number | null;
  onChange: (applicationId: number) => void;
  context?: 'route_create' | 'dogruz';
  routeId?: number;
  excludeRouteId?: number;
  disabled?: boolean;
  skip?: boolean;
};

export const AvailableApplicationPicker: React.FC<AvailableApplicationPickerProps> = ({
  value,
  onChange,
  context = 'route_create',
  routeId,
  excludeRouteId,
  disabled,
  skip
}) => {
  const [search, setSearch] = useState('');
  const { data, isFetching, isLoading } = useSelectableApplicationsQuery({
    context,
    search: search.trim() || undefined,
    limit: 50,
    routeId,
    excludeRouteId,
    skip
  });

  const options = useMemo(
    () => buildSelectableApplicationSelectOptions(data ?? []),
    [data]
  );

  return (
    <Select
      placeholder="Выберите заявку с доступным физическим источником"
      showSearch
      filterOption={false}
      onSearch={setSearch}
      notFoundContent={isFetching || isLoading ? <Spin size="small" /> : 'Нет заявок с доступным грузом'}
      options={options}
      value={value ?? undefined}
      disabled={disabled}
      onChange={(v) => {
        const appId = Number(v);
        if (Number.isFinite(appId) && appId > 0) onChange(appId);
      }}
      optionFilterProp="label"
    />
  );
};
